import AuthForm from './AuthForm'

export default AuthForm
